import { render, staticRenderFns } from "./SamplingLocationG.vue?vue&type=template&id=2e415dcc"
import script from "./SamplingLocationG.vue?vue&type=script&lang=js"
export * from "./SamplingLocationG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports